module.exports = __webpack_public_path__ + "static/media/node.50bb27f9.svg";